//import sistema from "./sistema/sipsic"
import funciones from './funcion/sipsic'
import catalogos from "./catalogos/sipsic"


const sipsic = {
  funciones: funciones,
  catalogos:catalogos,
  //sistema: sistema
}

export default sipsic;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIPSIC/sipsicapi.js
// module id = null
// module chunks = 